<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <AppHeader :title="$t('guest_student_application')"
                        :isNewButton="false"
                        @filter-div-status="datatable.filterStatus = $event">
                </AppHeader>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('guest_student_application')"
                              :isNewButton="false"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <DatatableFilter
             v-show="datatable.filterStatus"
             :exportExcel="true"
             @filter="filter" @filterClear="filterClear" @exportExcel="exportExcel">
                <b-tabs content-class="mt-3">
                    <b-tab :title="$t('personal_information')" active>
                        <b-row>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('national_id')">
                                    <b-form-input size="sm" v-model="datatable.queryParams.filter.identity"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('name')">
                                    <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('surname')">
                                    <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('nationality')">
                                    <CountrySelectbox
                                        v-model="datatable.queryParams.filter.nationality"
                                        valueType="code"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('program_information')">
                        <b-row>
                            <b-col sm="6" md="2">
                                <b-form-group :label="$t('academic_year')">
                                    <AcademicYearsSelectbox
                                        v-model="datatable.queryParams.filter.term"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="2">
                                <b-form-group :label="$t('program_level')">
                                    <ParameterSelectbox
                                        v-model="datatable.queryParams.filter.level"
                                        code="program_levels"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('faculty')">
                                    <FacultySelectbox
                                        v-model="datatable.queryParams.filter.faculty"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('department')">
                                    <DepartmentSelectbox
                                        :faculty_code="datatable.queryParams.filter.faculty_code"
                                        v-model="datatable.queryParams.filter.department"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="2">
                                <b-form-group :label="$t('program')">
                                    <ProgramSelectbox
                                        :faculty_code="datatable.queryParams.filter.faculty_code"
                                        :department_code="datatable.queryParams.filter.department_code"
                                        v-model="datatable.queryParams.filter.program"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="2">
                                <b-form-group :label="$t('with_without_thesis')">
                                    <ThesisWithTrueFalseSelectbox
                                        v-model="datatable.queryParams.filter.thesis"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('application_information')">
                        <b-row>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('accepttance_status')">
                                    <ParameterSelectbox
                                        v-model="datatable.queryParams.filter.acceptance"
                                        code="visitor_student_application_acceptance_statuses"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('application_completion_status')">
                                    <ParameterSelectbox
                                        v-model="datatable.queryParams.filter.completion"
                                        code="visitor_student_application_completion_statuses"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('application_status')">
                                    <ParameterSelectbox
                                        v-model="datatable.queryParams.filter.status"
                                        code="visitor_student_application_statuses"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('application_type')">
                                    <b-form-select size="sm" v-model="datatable.queryParams.filter.type" :options="['Seçiniz', '219 - Doktora Misafir Öğrenci', '228 - Misafir Öğrenci', '235 - Uluslararası Öğrenci (Doktora Misafir)', '233 - Uluslararası Öğrenci (YL Misafir)', '216 - Yüksek Lisans Misafir Öğrenci']"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </DatatableFilter>
            <!-- Datatable -->
            <Datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            ></Datatable>

            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <EditModal
                        v-if="formProcess === 'update'"
                        :applicationId="selectedApplication.id"
                        @saved="updateFormSuccess"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="showFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('guest_student').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <ShowModal
                        v-if="formProcess === 'show'"
                        :applicationId="selectedApplication.id"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import AppHeader from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import Datatable from "@/components/datatable/Datatable.vue";
import DatatableFilter from "@/components/datatable/DatatableFilter.vue";
import CommonModal from "@/components/elements/CommonModal.vue";
import EditModal from "../components/EditModal.vue";
import ShowModal from "../components/ShowModal.vue";
import CountrySelectbox from "@/components/interactive-fields/CountrySelectbox.vue";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox.vue";
import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox.vue";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox.vue";
import ThesisWithTrueFalseSelectbox from "@/components/interactive-fields/ThesisWithTrueFalseSelectbox.vue";
import VisitorStudentApplicationService from "@/services/VisitorStudentApplicationServices";
import qs from "qs";
import AnnouncementsService from "@/services/AnnouncementsService";
import DoubleMajorService from "@/services/DoubleMajorService";

export default {
    name: "AdminGuestStudentIndex",
    components: {
        AppLayout,
        AppHeader,
        HeaderMobile,
        Datatable,
        DatatableFilter,
        CommonModal,
        EditModal,
        ShowModal,
        CountrySelectbox,
        AcademicYearsSelectbox,
        ParameterSelectbox,
        FacultySelectbox,
        DepartmentSelectbox,
        ProgramSelectbox,
        ThesisWithTrueFalseSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('guest_student_application')
        }
    },
    data() {
        return {
            formProcess: null,
            selectedApplication: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line',
                                callback: (row) => {
                                    this.showForm(row);
                                },
                            },
                            {
                                text: this.$t('edit'),
                                class: 'ri-edit-box-line',
                                callback: (row) => {
                                    this.updateForm(row);
                                },
                            },
                            {
                                text: this.$t('download'),
                                class: 'ri-download-line',
                                callback: (row) => {
                                    this.download(row);
                                },
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-2-line',
                                callback: (row) => {
                                    this.formDelete(row.id);
                                },
                            }
                        ]
                    },
                    { label: this.$t('academic_year'), field: 'academic_year', sortable: false },
                    { label: this.$t('national_id'), field: 'national_id', sortable: false },
                    { label: this.$t('name'), field: 'name', sortable: false },
                    { label: this.$t('surname'), field: 'surname', sortable: false },
                    { label: this.$t('program'), field: 'program', sortable: false },
                    { label: this.$t('application_completion_status'), field: this.getLocaleField('completion_status_name'), sortable: false },
                    { label: this.$t('application_status'), field: this.getLocaleField('application_status_name'), sortable: false },
                ],
                rows: [],
                total: 1,
                filterStatus: true,
                showTable: true,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 15
                }
            }
        }
    },
    mounted() {
        this.getRows();
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.isLoading = true;
            const config = {
                params: this.datatable.queryParams,
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };
            VisitorStudentApplicationService.getAll(config)
                .then(response => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination?.total ?? response.data.total ?? 0;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        exportExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            VisitorStudentApplicationService.excelExport(config)
                .then(res => this._downloadFile(res, this.$t("guest_student_application") + '.xlsx'))
                .catch(err => this.showErrors(err))
        },
        formClear() {
            this.formProcess = null;
            this.selectedApplication = null;
        },
        showForm(row) {
            this.selectedApplication = row;
            this.formProcess = 'show';
            this.$nextTick(() => {
                this.$refs.showFormModal.$refs.commonModal.show();
            });
        },
        updateForm(row) {
            this.selectedApplication = row;
            this.formProcess = 'update';
            this.$nextTick(() => {
                this.$refs.updateFormModal.$refs.commonModal.show();
            });
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide();
            this.filter();
            this.formClear();
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        VisitorStudentApplicationService.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },
        download(row) {
            VisitorStudentApplicationService.downloadForm(row.id)
                .then(response=>{
                    this._downloadFile(response, 'guest_student_application' + '.pdf')
                }).catch(e => {
                this.showErrors(e, null, true)
            })
        },
    }
}
</script>
